import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PartnerShell, Notice } from "@/pages/partners/PartnerShell";
import { api, errMsg } from "@/lib/api";

export default function PartnerAccess() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/public/partners/access", { email }); setSent(true); } catch (er) { toast.error(errMsg(er)); }
    setBusy(false);
  };
  return (
    <PartnerShell>
      {sent ? <Notice testId="partner-access-sent" title="Verifique seu e-mail" text="Se este e-mail estiver cadastrado, você vai receber o link do seu painel em instantes. É sempre o mesmo link." /> : (
        <form onSubmit={submit} className="card-surface mx-auto max-w-lg space-y-4 p-6" data-testid="partner-access-form">
          <div>
            <h1 className="font-display text-2xl font-bold">Entrar no painel de parceiro</h1>
            <p className="mt-1 text-sm text-muted-foreground">Digite o e-mail do seu cadastro. Enviamos o link do seu painel para ele.</p>
          </div>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="seu@email.com" data-testid="partner-access-email-input" />
          <Button type="submit" className="w-full" disabled={busy} data-testid="partner-access-submit-btn">{busy ? "Enviando..." : "Receber meu link"}</Button>
        </form>
      )}
    </PartnerShell>
  );
}
